export default __webpack_public_path__ + "static/media/2_nearshorit-image.2b7e54ae.jpg";